import { render, staticRenderFns } from "./audit-workcenter-dashboard.vue?vue&type=template&id=6dba779a&scoped=true&"
import script from "./js/audit-workcenter-dashboard.js?vue&type=script&lang=js&"
export * from "./js/audit-workcenter-dashboard.js?vue&type=script&lang=js&"
import style0 from "./audit-workcenter-dashboard.vue?vue&type=style&index=0&id=6dba779a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dba779a",
  null
  
)

export default component.exports